import { isObject } from '../is-object';
export function isActionContentObject(obj) {
  return isObject(obj);
}